export default {
	/* Types of page on fury */
	CP: 'CP',
	PDP: 'PDP',
	CS: 'crosssellings',
	BASKET: 'basket',
	WISHLIST: 'wishlist',
	MAGENTO: 'magento',
};
